import DynamicFieldSelect from "./DynamicFieldSelect";

export default DynamicFieldSelect;



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldSelect/index.js